{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=258",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    },
    "file": ""
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "stacklight": {
    "colorValues": {
      "0": "off",
      "1": "red",
      "2": "green",
      "3": "blue",
      "4": "yellow",
      "5": "purple",
      "6": "cyan",
      "7": "white"
    },
    "lampsPlaceholderObject": "Monitoring.Stacklight.<OrderedObject>.[PLACEHOLDER]",
    "signalVariable": {
      "id": "cf0c5a55-a8e8-4e94-85fe-043769fe0094",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=310",
      "displayName": "SignalOn",
      "variablePath": "SignalOn",
      "dataType": "Boolean",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "signalOnValue": "true",
    "signalOffValue": "false",
    "sortingVariable": {
      "id": "a816aca4-1b70-48f9-b95b-53bb304a80bc",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=226",
      "displayName": "NumberInList",
      "variablePath": "NumberInList",
      "dataType": "UInteger",
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "hasUnit": false,
      "hasRange": false
    },
    "colorVariable": {
      "id": "e022d6f0-95b5-4ca7-a2a3-f25e88a68767",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=290",
      "displayName": "SignalColor",
      "variablePath": "SignalColor",
      "dataType": "SignalColor",
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "timeline": {
    "variable": {
      "id": "b15a1091-4010-4719-87d1-6594ce4aad80",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=6038",
      "displayName": "Number",
      "variablePath": "Production.ActiveProgram.State.CurrentState.properties.Number",
      "dataType": "UInt32",
      "modellingRule": "Mandatory",
      "hasProperties": false,
      "hasUnit": false,
      "hasRange": false
    },
    "colorValues": {
      "0": "#eaeaea",
      "1": "#00b20e",
      "2": "#17a2b8",
      "3": "#ffc107",
      "4": "#ff4136"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "d6837b4b-bae5-4a5f-bd02-71ddd1141162",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=182",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "d6b618a2-0ac5-4746-9778-4d9cead71d30",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=258",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "e40be8f5-7940-410f-ad25-c90e6aa9135a",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=259",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "ddc4aaca-9595-49c0-b3bc-e39c52f20131",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "valueVariable": {
                "id": "b5b7d4a8-097f-4c4f-8818-edb4a0a7e2de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "2890fa7a-5aa6-4579-b834-92597590b573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Tools",
      "rows": [
        {
          "isPlaceholder": true,
          "placeholderObject": "Equipment.Tools.<Tool>.[PLACEHOLDER]",
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=50",
            "displayName": "ToolType",
            "typeDefinition": "nsu=http://opcfoundation.org/UA/MachineTool/;i=50",
            "subTypes": []
          },
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Control Identifier Interpretation",
              "valueVariable": {
                "id": "ebd23dd2-fc98-4722-8a29-33c32dfe1bb0",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=297",
                "displayName": "ControlIdentifierInterpretation",
                "variablePath": "ControlIdentifierInterpretation",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "NumberBased",
                  "1": "GroupBased",
                  "2": "Other"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Identifier",
              "valueVariable": {
                "id": "1cd20daf-17eb-4c96-a367-ce3b20f663ce",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=178",
                "displayName": "ControlIdentifier1",
                "variablePath": "ControlIdentifier1",
                "dataType": "UInt32",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "valueVariable": {
                "id": "6e602aa0-03f1-4894-847c-94d5c2e42f81",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=176",
                "displayName": "Name",
                "variablePath": "Name",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#DC3545",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Locked"
                },
                {
                  "backgroundColor": "#198754",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Active"
                }
              ],
              "valueVariable": {
                "id": "9d05e2ce-a883-42f9-a6e8-aee5a0e71195",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=179",
                "displayName": "Locked",
                "variablePath": "Locked",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        },
        {
          "isPlaceholder": true,
          "placeholderObject": "Equipment.Tools.<Tool>.[PLACEHOLDER].<Tool>.[PLACEHOLDER]",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Control Identifier Interpretation",
              "valueVariable": {
                "id": "ebd23dd2-fc98-4722-8a29-33c32dfe1bb0",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=297",
                "displayName": "ControlIdentifierInterpretation",
                "variablePath": "ControlIdentifierInterpretation",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "NumberBased",
                  "1": "GroupBased",
                  "2": "Other"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Identifier",
              "valueVariable": {
                "id": "1cd20daf-17eb-4c96-a367-ce3b20f663ce",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=178",
                "displayName": "ControlIdentifier1",
                "variablePath": "ControlIdentifier1",
                "dataType": "UInt32",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "valueVariable": {
                "id": "21ccf4bc-81c5-4f64-ae30-5e236e9caf86",
                "modelUri": "https://opcfoundation.org/UA/",
                "nodeId": "i=61",
                "displayName": "baseName",
                "variablePath": "baseName",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#DC3545",
                  "textColor": "#ffffff",
                  "value": "true",
                  "label": "Locked"
                },
                {
                  "backgroundColor": "#198754",
                  "textColor": "#ffffff",
                  "value": "false",
                  "label": "Active"
                }
              ],
              "valueVariable": {
                "id": "9d05e2ce-a883-42f9-a6e8-aee5a0e71195",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=179",
                "displayName": "Locked",
                "variablePath": "Locked",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Active Program",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Name",
              "valueVariable": {
                "id": "a4ca1f61-bc50-470b-bca6-10fea9b6e1d9",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=174",
                "displayName": "Name",
                "variablePath": "Production.ActiveProgram.Name",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "State Id",
              "valueVariable": {
                "id": "f368095d-9656-47ce-a939-8fd023115721",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6037",
                "displayName": "Id",
                "variablePath": "Production.ActiveProgram.State.CurrentState.properties.Id",
                "dataType": "NodeId",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 2,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "f639a7b5-7f25-4e88-ab1a-a0690c47a100",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=6036",
                "displayName": "CurrentState",
                "variablePath": "Production.ActiveProgram.State.CurrentState",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": true
              },
              "badgeValues": [
                {
                  "backgroundColor": "#eaeaea",
                  "textColor": "#000000",
                  "value": "Initializing"
                },
                {
                  "backgroundColor": "#00b20e",
                  "textColor": "#ffffff",
                  "value": "Running"
                },
                {
                  "backgroundColor": "#17a2b8",
                  "textColor": "#ffffff",
                  "value": "Ended"
                },
                {
                  "backgroundColor": "#ffc107",
                  "textColor": "#000000",
                  "value": "Interrupted"
                },
                {
                  "backgroundColor": "#ff4136",
                  "textColor": "#ffffff",
                  "value": "Aborted"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "title": "Machine Tool",
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operation Mode",
              "valueVariable": {
                "id": "0abde462-a3c2-4747-b3ce-74c5c74a4859",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=263",
                "displayName": "OperationMode",
                "variablePath": "Monitoring.MachineTool.OperationMode",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "Manual",
                  "1": "Automatic",
                  "2": "Setup",
                  "3": "AutoWithManualIntervention",
                  "4": "Service",
                  "5": "Other"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Power On Duration",
              "valueVariable": {
                "id": "57760161-0187-4c60-9af1-1e2752aa84d2",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=261",
                "displayName": "PowerOnDuration",
                "variablePath": "Monitoring.MachineTool.PowerOnDuration",
                "dataType": "UInt32",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "FeedOverride",
              "valueVariable": {
                "id": "4d6933fd-2990-47d3-94f1-dad307b30fad",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=233",
                "displayName": "FeedOverride",
                "variablePath": "Monitoring.MachineTool.FeedOverride",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ]
        },
        {
          "isPlaceholder": true,
          "titleVariable": {
            "id": "b4dc4e93-3497-4680-8667-c14ba2ca8590",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=284",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Channel Mode",
              "valueVariable": {
                "id": "7b5d8ac3-4ff7-4af7-9475-a9fa3837e5fb",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=249",
                "displayName": "ChannelMode",
                "variablePath": "ChannelMode",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "Automatic",
                  "1": "MdaMdi",
                  "2": "JogManual",
                  "3": "JogIncrement",
                  "4": "TeachingHandle",
                  "5": "Remote",
                  "6": "Reference",
                  "7": "Other"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Channel State",
              "valueVariable": {
                "id": "e3da2880-eaf8-4f7b-933d-0d7490af2845",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=332",
                "displayName": "ChannelState",
                "variablePath": "ChannelState",
                "dataType": "Enum",
                "modellingRule": "Mandatory",
                "hasProperties": false,
                "enumValues": {
                  "0": "Active",
                  "1": "Interrupted",
                  "2": "Reset"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Minimal Override",
              "valueVariable": {
                "id": "d84b2df7-ceb6-4b6c-b2a6-1b1c08f70ec1",
                "modelUri": "",
                "nodeId": "",
                "displayName": "Low",
                "variablePath": "FeedOverride.properties.EURange.Low",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Maximum Override",
              "valueVariable": {
                "id": "2d8228b5-a5c6-4538-b7e9-ddd420d92b10",
                "modelUri": "",
                "nodeId": "",
                "displayName": "High",
                "variablePath": "FeedOverride.properties.EURange.High",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "FeedOverride",
              "valueVariable": {
                "id": "a9516d7b-88eb-4474-a564-b58702057ac4",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=276",
                "displayName": "FeedOverride",
                "variablePath": "FeedOverride",
                "dataType": "Double",
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=16",
            "displayName": "ChannelMonitoringType",
            "typeDefinition": "nsu=http://DMGMORI.com/UA/OemExtensions/;i=1006",
            "subTypes": []
          },
          "placeholderObject": "Monitoring.<MonitoredElement>.[PLACEHOLDER]"
        },
        {
          "isPlaceholder": true,
          "titleVariable": {
            "id": "233cc62f-dae5-47e1-9d8f-f93795af65d9",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=284",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "State (is rotating)",
              "valueVariable": {
                "id": "b1374cbd-58ee-4e9d-b538-8065bcd1a94d",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=247",
                "displayName": "IsRotating",
                "variablePath": "IsRotating",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "State (is used as axis)",
              "valueVariable": {
                "id": "ca3cb5dd-560e-4178-a73a-3e1fb6714a0e",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=371",
                "displayName": "IsUsedAsAxis",
                "variablePath": "IsUsedAsAxis",
                "dataType": "Boolean",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Override",
              "valueVariable": {
                "id": "59b0ffb8-8e6f-4ad0-97eb-c529ce0b1d54",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=241",
                "displayName": "Override",
                "variablePath": "Override",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=22",
            "displayName": "SpindleMonitoringType",
            "typeDefinition": "nsu=http://DMGMORI.com/UA/OemExtensions/;i=1008",
            "subTypes": []
          },
          "placeholderObject": "Monitoring.<MonitoredElement>.[PLACEHOLDER]"
        },
        {
          "isPlaceholder": true,
          "titleVariable": {
            "id": "233cc62f-dae5-47e1-9d8f-f93795af65d9",
            "modelUri": "http://opcfoundation.org/UA/MachineTool/",
            "nodeId": "ns=1;i=284",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "State (is rotating)",
              "valueVariable": {
                "id": "b1374cbd-58ee-4e9d-b538-8065bcd1a94d",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=247",
                "displayName": "IsRotating",
                "variablePath": "IsRotating",
                "dataType": "Boolean",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "State (is used as axis)",
              "valueVariable": {
                "id": "ca3cb5dd-560e-4178-a73a-3e1fb6714a0e",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=371",
                "displayName": "IsUsedAsAxis",
                "variablePath": "IsUsedAsAxis",
                "dataType": "Boolean",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "FeedOverride",
              "valueVariable": {
                "id": "59b0ffb8-8e6f-4ad0-97eb-c529ce0b1d54",
                "modelUri": "http://opcfoundation.org/UA/MachineTool/",
                "nodeId": "ns=1;i=241",
                "displayName": "Override",
                "variablePath": "Override",
                "dataType": "Double",
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "AirGap",
              "valueVariable": {
                "id": "1fbff0c1-2a46-4f2c-91a6-d36439a3ec68",
                "modelUri": "http://lenord.de/umati/MiniCODER/",
                "nodeId": "ns=1;i=6011",
                "displayName": "Airgap",
                "variablePath": "Airgap",
                "dataType": "Double",
                "valueRank": -2,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "2df2c460-a0a8-4ab7-90df-aaaa1386d10a",
                "modelUri": "http://lenord.de/umati/MiniCODER/",
                "nodeId": "ns=1;i=6009",
                "displayName": "Rpm",
                "variablePath": "Rpm",
                "dataType": "Double",
                "valueRank": -2,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              },
              "label": "Rpm"
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "cfcaf5ae-f504-4226-b7fa-0b5d9820e28e",
                "modelUri": "http://lenord.de/umati/MiniCODER/",
                "nodeId": "ns=1;i=6010",
                "displayName": "Temperature",
                "variablePath": "Temperature",
                "dataType": "Double",
                "valueRank": -2,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              },
              "label": "Temperature"
            }
          ],
          "placeholderConditionType": {
            "modelUri": "http://lenord.de/umati/MiniCODER/",
            "nodeId": "ns=1;i=1002",
            "displayName": "ObserverMonitoringType",
            "typeDefinition": "nsu=http://lenord.de/umati/MiniCODER/;i=1002",
            "subTypes": []
          },
          "placeholderObject": "Monitoring.<MonitoredElement>.[PLACEHOLDER]"
        }
      ]
    }
  ]
}
